<template>
  <CockpitDialog
    title="两票详情"
    :top="'150px'"
    :left="'500px'"
    :width="'1000px'"
    :height="'600px'"
    @close="close"
  >
    <div class="text-white detail-container">
      <div class="detail-item">
        <span class="detail-label">设备：</span>
        <span class="detail-value">{{ detailInfo.device }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">班组：</span>
        <span class="detail-value">{{ detailInfo.group }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">编号：</span>
        <span class="detail-value">{{ detailInfo.gzpdh }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">两票类型：</span>
        <span class="detail-value">{{ detailInfo.gzptype }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">负责人：</span>
        <span class="detail-value">{{ detailInfo.gzpleader }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">负责人编码：</span>
        <span class="detail-value">{{ detailInfo.perscode }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">电话：</span>
        <span class="detail-value">{{ detailInfo.phone }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">工作人：</span>
        <span class="detail-value">{{ detailInfo.workerlist }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">工作内容：</span>
        <span class="detail-value">{{ detailInfo.workcontent }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">工作地址：</span>
        <span class="detail-value">{{ detailInfo.workaddress }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">开始时间：</span>
        <span class="detail-value">{{ detailInfo.starttime }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">结束时间：</span>
        <span class="detail-value">{{ detailInfo.endtime }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">状态：</span>
        <span class="detail-value">{{ detailInfo.gzpstep }}</span>
      </div>
    </div>

  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'

export default {
  name: 'TaskDetailDialog',
  components: {
    CockpitDialog,
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.detail-container {
  padding: 10px;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.detail-label {
  width: 100px;
  flex-shrink: 0;
  color: #86e0ff;
  font-weight: 500;
}

.detail-value {
  flex: 1;
  word-break: break-all;
}
</style>
